import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { forkJoin } from 'rxjs';
import { UtilService } from '../util';
import { ActivatedRoute } from '@angular/router';

import { WelcomeOkModel} from './index';
import { TranslateService } from "@ngx-translate/core";

import './welcome-ok.component.css';

@Component({
    selector: 'welcome-ok',
    templateUrl: 'welcome-ok.component.html'
})
export class WelcomeOkComponent implements OnInit {

    public orderId : String;
    public token : any;
    public currencyCode : any;
    private canSubmitForm : boolean = false;
    public inProgress : boolean = false;
    public link : string = null;

    @Input() welcomeOk : WelcomeOkModel = new WelcomeOkModel();

    constructor(private http: HttpClient,
                private utilService: UtilService,
                private route: ActivatedRoute,
                private translate: TranslateService) {
    }

    ngOnInit() {
        this.route.params.subscribe( params => {
            this.link = params['link'];
        });

        let landingPageQuery = this.http.get<WelcomeOkModel>(`/api/landingPage/${this.link}`);
        let orderIdQuery = this.http.post<any>(`/api/orderId/${this.link}`, {});

        forkJoin([landingPageQuery, orderIdQuery]).subscribe(result => {
            this.welcomeOk = result[0];
            this.translate.setDefaultLang(this.welcomeOk.language.toLowerCase());
            this.orderId = result[1].value;
            this.currencyCode = this.utilService.currencyCode(this.welcomeOk.currency);
            this.canSubmitForm = true;
        });
    }

    merchantNameTranslate() {
        return {merchantName : this.welcomeOk.merchantName};
    }

    paymentDateTranslate() {
        return {paymentDate : this.welcomeOk.paymentDate};
    }

    canSubmit() {
        return this.canSubmitForm && !this.inProgress;
    }

    onBuyClick() {
        this.inProgress = true;
        this.http.post('/api/token', {
            'apiUser': this.welcomeOk.apiUser,
            'apiPassword': this.welcomeOk.apiPassword,
            'mid': this.welcomeOk.mid,
            'storeKey': this.welcomeOk.storeKey,
            'orderId': this.orderId,
            'total': this.welcomeOk.amount,
            'currencyCode': this.currencyCode,
        }).subscribe(
            (data : any) => {
                this.token = data.value;
                this.http.put<any>(`/api/token`, {
                    'orderId': this.orderId,
                    'token': this.token
                }).subscribe(data => {
                    let element: HTMLElement = document.getElementById('postFormSubmit');
                    console.log("Before redirect to NestPay");
                    element.click();
                }, error => {
                    this.inProgress = false;
                });
            }
        );
    }
}